import React from 'react';
import { Box, Switch, Typography } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import LightbulbOutlinedIcon from '@mui/icons-material/LightbulbOutlined';
import ColumnSectionHeader from '../ColumnSectionHeader';
import ComingSoonBadge from '../ComingSoonBadge';
import { GTM_DOCTRINE_ITEMS } from '../constants';
import { blurredActionSx } from '../blurStyles';

const GtmDoctrineColumn = () => (
  <Box
    border={1}
    borderColor='divider'
    borderRadius={2}
    p={2.5}
    display='flex'
    flexDirection='column'
    minHeight={{ md: 640 }}
    bgcolor='#fff'
  >
    <ColumnSectionHeader
      number={3}
      title='GTM Doctrine'
      subtitle='Add additional guidance for how Lead Agents should represent your company and approach prospects.'
      endAdornment={<ComingSoonBadge />}
    />

    <Box
      display='flex'
      gap={1.25}
      p={1.5}
      mb={2}
      borderRadius={1.5}
      sx={{ bgcolor: '#fff7ed', border: '1px solid #fed7aa' }}
    >
      <LightbulbOutlinedIcon sx={{ fontSize: 20, color: '#c2410c', mt: 0.15 }} />
      <Typography variant='body2' color='text.secondary' sx={{ lineHeight: 1.5 }}>
        Draft in progress. We’re preparing a draft GTM Doctrine from your sources. You can review it
        here soon.
      </Typography>
    </Box>

    <Typography variant='subtitle2' fontWeight={700} mb={1}>
      This will include:
    </Typography>
    <Box display='flex' flexDirection='column' gap={0.75} mb={3}>
      {GTM_DOCTRINE_ITEMS.map((item) => (
        <Box key={item} display='flex' alignItems='center' gap={1}>
          <CheckCircleOutlineIcon sx={{ fontSize: 18, color: 'success.main' }} />
          <Typography variant='body2'>{item}</Typography>
        </Box>
      ))}
    </Box>

    <Box mt='auto' pt={2} borderTop={1} borderColor='divider'>
      <Box display='flex' alignItems='center' justifyContent='space-between' gap={1} sx={blurredActionSx}>
        <Typography variant='body2' fontWeight={700}>
          Use GTM Doctrine
        </Typography>
        <Box display='flex' alignItems='center' gap={0.75}>
          <Typography variant='caption' color='text.secondary'>
            Off
          </Typography>
          <Switch checked={false} disabled size='small' />
        </Box>
      </Box>
      <Typography variant='caption' color='text.secondary' display='block' mt={1} sx={{ lineHeight: 1.5 }}>
        When enabled, this guidance will be used for Lead Agent communications. Available once GTM
        Doctrine is ready.
      </Typography>
    </Box>
  </Box>
);

export default GtmDoctrineColumn;
